export interface ComicItem {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  description: string;
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  author: string;
  rating: number;
  views: string;
  chapters: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const heroComics: ComicItem[] = [
  {
    id: 1,
    title: '女神降临',
    slug: 'goddess-advent',
    category: '恋爱',
    categorySlug: 'romance',
    description: '平凡女孩通过化妆逆袭成为校园女神，却意外卷入三角恋情，甜蜜又虐心的青春故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20stunning%20young%20woman%20with%20long%20dark%20hair%20transforming%20through%20makeup%2C%20soft%20romantic%20atmosphere%2C%20pastel%20pink%20and%20lavender%20background%2C%20delicate%20facial%20features%2C%20sparkling%20effects%2C%20manga%20aesthetic%2C%20clean%20composition%2C%20high%20quality%20digital%20art&width=800&height=1067&seq=hero-comic-01&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Yaongyi',
    rating: 4.9,
    views: '3268万',
    chapters: 256,
    tags: ['恋爱', '校园', '逆袭', '美妆'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '我独自升级',
    slug: 'solo-leveling',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '最弱猎人觉醒系统逆天改命，从E级菜鸟一路成长为人类最强战士，热血升级之路。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20dark%20haired%20male%20warrior%20in%20black%20armor%20with%20glowing%20purple%20energy%20aura%2C%20epic%20fantasy%20battle%20scene%2C%20dramatic%20lighting%2C%20dark%20shadowy%20background%20with%20neon%20accents%2C%20dynamic%20pose%2C%20intense%20expression%2C%20high%20contrast%2C%20action%20packed%20composition&width=800&height=1067&seq=hero-comic-02&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Chugong',
    rating: 4.8,
    views: '5892万',
    chapters: 179,
    tags: ['奇幻', '战斗', '升级', '系统'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '全知读者视角',
    slug: 'omniscient-reader',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '小说中的世界成为现实，唯一知道结局的读者踏上改写命运的征程，智斗与热血并存。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20art%20of%20a%20clever%20young%20man%20holding%20a%20glowing%20book%20in%20a%20post%20apocalyptic%20fantasy%20world%2C%20mysterious%20atmosphere%2C%20golden%20and%20teal%20color%20scheme%2C%20magical%20particles%20floating%20around%2C%20dramatic%20shadows%2C%20clean%20digital%20illustration%20style&width=800&height=1067&seq=hero-comic-03&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'sing N song',
    rating: 4.7,
    views: '4521万',
    chapters: 210,
    tags: ['奇幻', '智斗', '末世', '冒险'],
    isHot: true,
    isNew: false,
  },
];

export const hotComics: ComicItem[] = [
  {
    id: 4,
    title: '社长大人别过来',
    slug: 'boss-stay-away',
    category: '恋爱',
    categorySlug: 'romance',
    description: '职场菜鸟误入霸道总裁的陷阱，甜蜜又搞笑的办公室恋情，让人欲罢不能。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20illustration%20of%20a%20handsome%20CEO%20man%20in%20suit%20and%20a%20cute%20office%20woman%2C%20romantic%20office%20setting%2C%20soft%20warm%20lighting%2C%20pink%20and%20cream%20tones%2C%20elegant%20composition%2C%20sweet%20atmosphere%2C%20high%20quality%20digital%20art&width=800&height=1067&seq=hot-comic-01&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Lee Hye',
    rating: 4.6,
    views: '2156万',
    chapters: 189,
    tags: ['恋爱', '职场', '总裁', '甜宠'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '剑尊归来',
    slug: 'sword-master-returns',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '陨落千年的剑道至尊重生归来，手握绝世剑法横扫天下，快意恩仇的武侠奇幻巨作。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20illustration%20of%20a%20swordsman%20with%20flowing%20white%20hair%20holding%20a%20glowing%20ancient%20sword%2C%20mountain%20peak%20background%20with%20moonlight%2C%20dramatic%20wind%20effects%2C%20elegant%20traditional%20robe%2C%20epic%20atmosphere%2C%20high%20contrast%20lighting&width=800&height=1067&seq=hot-comic-02&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Kim Daehyun',
    rating: 4.7,
    views: '3876万',
    chapters: 167,
    tags: ['奇幻', '武侠', '重生', '战斗'],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '梨泰院Class',
    slug: 'itaewon-class',
    category: '剧情',
    categorySlug: 'drama',
    description: '热血青年在梨泰院创业复仇的励志故事，坚持信念不向命运低头的人生传奇。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20style%20illustration%20of%20a%20determined%20young%20man%20standing%20in%20front%20of%20a%20restaurant%20at%20night%20in%20Itaewon%20street%2C%20neon%20signs%20glowing%2C%20warm%20and%20cool%20color%20contrast%2C%20urban%20nightlife%20atmosphere%2C%20cinematic%20composition&width=800&height=1067&seq=hot-comic-03&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Kwang Jin',
    rating: 4.8,
    views: '4765万',
    chapters: 192,
    tags: ['剧情', '励志', '创业', '复仇'],
    isHot: true,
    isNew: false,
  },
];

export const latestComics: ComicItem[] = [
  {
    id: 7,
    title: '恶女的重生',
    slug: 'villainess-reborn',
    category: '恋爱',
    categorySlug: 'romance',
    description: '被陷害而死的公爵千金重生回到婚礼当天，这一次她要让所有仇人付出代价。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20illustration%20of%20an%20elegant%20noblewoman%20in%20a%20lavish%20Victorian%20style%20gown%2C%20palace%20ballroom%20background%2C%20golden%20chandeliers%2C%20dramatic%20revenge%20theme%2C%20deep%20burgundy%20and%20gold%20color%20scheme%2C%20mysterious%20expression%2C%20intricate%20details&width=800&height=1067&seq=latest-comic-01&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Park Sohee',
    rating: 4.5,
    views: '1567万',
    chapters: 134,
    tags: ['恋爱', '重生', '复仇', '宫廷'],
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '末日生存指南',
    slug: 'apocalypse-survival',
    category: '惊悚',
    categorySlug: 'thriller',
    description: '丧尸病毒爆发后的首尔，一群幸存者在绝境中挣扎求生，人性与生存的残酷考验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20survival%20manhwa%20illustration%20of%20survivors%20in%20post%20apocalyptic%20Seoul%20with%20destroyed%20buildings%2C%20dark%20ominous%20sky%2C%20tense%20atmosphere%2C%20characters%20holding%20weapons%2C%20dramatic%20lighting%2C%20gritty%20realistic%20style%2C%20cool%20gray%20and%20olive%20tones&width=800&height=1067&seq=latest-comic-02&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Jung Minwoo',
    rating: 4.6,
    views: '2341万',
    chapters: 98,
    tags: ['惊悚', '丧尸', '生存', '末世'],
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: '月光雕刻师',
    slug: 'moonlight-sculptor',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '负债累累的青年在虚拟现实游戏中走上雕刻师之路，以独特职业征服整个游戏世界。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20illustration%20of%20a%20young%20sculptor%20in%20a%20magical%20VR%20game%20world%2C%20moonlight%20glowing%20on%20a%20beautiful%20statue%2C%20fantasy%20landscape%20with%20floating%20islands%2C%20silver%20and%20blue%20color%20palette%2C%20dreamy%20atmosphere%2C%20detailed%20character%20design&width=800&height=1067&seq=latest-comic-03&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Nam Heesung',
    rating: 4.4,
    views: '1897万',
    chapters: 145,
    tags: ['奇幻', '游戏', '冒险', 'VR'],
    isHot: false,
    isNew: true,
  },
];

export const categories = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 1256 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 987 },
  { name: '剧情', slug: 'drama', icon: 'ri-emotion-line', count: 654 },
  { name: '惊悚', slug: 'thriller', icon: 'ri-ghost-line', count: 432 },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', count: 789 },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 567 },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line', count: 345 },
  { name: '历史', slug: 'historical', icon: 'ri-ancient-gate-line', count: 234 },
];

export const reviews = [
  {
    id: 1,
    name: '小雨',
    text: '韩漫之家的漫画资源真的太全了！我追的几部热门韩漫这里都能找到，而且更新速度超快，画质也很清晰，阅读体验一级棒！',
    rating: 5,
    date: '2026-06-28',
  },
  {
    id: 2,
    name: '星辰大海',
    text: '作为一个韩漫重度爱好者，用过很多平台，韩漫之家是我最喜欢的。界面简洁清爽，没有乱七八糟的广告，阅读非常流畅。',
    rating: 5,
    date: '2026-06-25',
  },
  {
    id: 3,
    name: '樱花树下',
    text: '分类非常细致，找漫画特别方便。而且推荐算法很准，每次都能给我推荐到喜欢的漫画，已经在这里追了十几部了！',
    rating: 4,
    date: '2026-06-20',
  },
];

export const extraComics: ComicItem[] = [
  {
    id: 10,
    title: '神之塔',
    slug: 'tower-of-god',
    category: '动作',
    categorySlug: 'action',
    description: '少年为了追寻心爱之人踏入神秘巨塔，每一层都是生死考验，热血与友情交织的史诗冒险。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20illustration%20of%20a%20determined%20young%20warrior%20climbing%20a%20mysterious%20towering%20structure%2C%20epic%20scale%2C%20dramatic%20lighting%20with%20golden%20rays%2C%20dynamic%20action%20pose%2C%20fantasy%20world%20with%20floating%20platforms%2C%20intense%20atmosphere%2C%20detailed%20background&width=800&height=1067&seq=all-comic-10&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'SIU',
    rating: 4.8,
    views: '5123万',
    chapters: 550,
    tags: ['动作', '冒险', '奇幻', '友情'],
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: '狂王',
    slug: 'mad-king',
    category: '动作',
    categorySlug: 'action',
    description: '被驱逐的王子在边境崛起，以铁血手段统一蛮族，挥师中原夺回属于自己的一切。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20illustration%20of%20a%20fierce%20warrior%20king%20with%20battle%20armor%20standing%20on%20a%20battlefield%2C%20dramatic%20sunset%20sky%2C%20sword%20raised%20high%2C%20epic%20war%20scene%2C%20red%20and%20gold%20color%20scheme%2C%20powerful%20stance%2C%20dust%20and%20wind%20effects&width=800&height=1067&seq=all-comic-11&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Kim Jinwoo',
    rating: 4.6,
    views: '2876万',
    chapters: 198,
    tags: ['动作', '战争', '复仇', '历史'],
    isHot: true,
    isNew: false,
  },
  {
    id: 12,
    title: '搞笑一家人',
    slug: 'funny-family',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '四口之家的爆笑日常，每个家庭成员都有不为人知的秘密，笑中带泪的温情喜剧。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20illustration%20of%20a%20chaotic%20family%20scene%20in%20a%20living%20room%2C%20exaggerated%20cartoon%20expressions%2C%20bright%20warm%20colors%2C%20messy%20but%20cozy%20home%20atmosphere%2C%20funny%20character%20interactions%2C%20lighthearted%20and%20humorous%20style%2C%20comic%20book%20aesthetic&width=800&height=1067&seq=all-comic-12&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Park Hyesun',
    rating: 4.5,
    views: '3456万',
    chapters: 312,
    tags: ['搞笑', '日常', '家庭', '治愈'],
    isHot: false,
    isNew: true,
  },
  {
    id: 13,
    title: '宅男生存记',
    slug: 'otaku-survival',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '资深宅男意外穿越到异世界，用现代宅文化知识在剑与魔法的世界里掀起一场文化革命。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20fantasy%20manhwa%20illustration%20of%20a%20nerdy%20guy%20with%20glasses%20in%20a%20medieval%20fantasy%20world%20looking%20confused%2C%20colorful%20magic%20effects%2C%20contrast%20between%20modern%20and%20fantasy%20elements%2C%20humorous%20scene%2C%20bright%20saturated%20colors%2C%20cartoonish%20expressions&width=800&height=1067&seq=all-comic-13&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Lee Dongsoo',
    rating: 4.3,
    views: '1678万',
    chapters: 89,
    tags: ['搞笑', '穿越', '奇幻', '宅文化'],
    isHot: false,
    isNew: true,
  },
  {
    id: 14,
    title: '咖啡店日常',
    slug: 'cafe-daily',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '街角一家小小咖啡店里顾客与店主之间的温情故事，每一杯咖啡都承载着一段人生。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20illustration%20of%20a%20cozy%20small%20cafe%20interior%20with%20warm%20sunlight%20through%20windows%2C%20barista%20making%20coffee%2C%20soft%20pastel%20color%20palette%2C%20relaxing%20atmosphere%2C%20gentle%20scenes%20of%20daily%20life%2C%20watercolor%20art%20style%2C%20peaceful%20composition&width=800&height=1067&seq=all-comic-14&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Choi Yuna',
    rating: 4.7,
    views: '2134万',
    chapters: 145,
    tags: ['日常', '治愈', '咖啡', '人生'],
    isHot: false,
    isNew: false,
  },
  {
    id: 15,
    title: '春天的约定',
    slug: 'spring-promise',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '两个儿时玩伴在樱花盛开的季节重逢，关于成长、离别与重逢的温暖青春物语。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20illustration%20of%20two%20friends%20reuniting%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pink%20and%20white%20color%20palette%2C%20gentle%20breeze%20with%20falling%20petals%2C%20nostalgic%20atmosphere%2C%20beautiful%20landscape%2C%20emotional%20reunion%20scene%2C%20warm%20sunlight&width=800&height=1067&seq=all-comic-15&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Jung Sooyoung',
    rating: 4.4,
    views: '987万',
    chapters: 67,
    tags: ['日常', '青春', '友情', '治愈'],
    isHot: false,
    isNew: true,
  },
  {
    id: 16,
    title: '朝鲜王朝实录',
    slug: 'joseon-chronicles',
    category: '历史',
    categorySlug: 'historical',
    description: '以漫画形式还原朝鲜王朝五百年兴衰史，从建国到鼎盛再到衰落，波澜壮阔的历史画卷。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20illustration%20of%20a%20Joseon%20dynasty%20royal%20court%20scene%2C%20traditional%20Korean%20architecture%20and%20hanbok%20clothing%2C%20ancient%20palace%20interior%2C%20dramatic%20composition%2C%20rich%20warm%20earth%20tones%2C%20historical%20authenticity%2C%20elegant%20royal%20atmosphere%2C%20detailed%20traditional%20patterns&width=800&height=1067&seq=all-comic-16&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Yoon Taekyung',
    rating: 4.6,
    views: '1567万',
    chapters: 234,
    tags: ['历史', '宫廷', '权谋', '纪实'],
    isHot: false,
    isNew: false,
  },
  {
    id: 17,
    title: '花郎传说',
    slug: 'hwarang-legend',
    category: '历史',
    categorySlug: 'historical',
    description: '新罗时期花郎少年的成长与冒险，在战火与爱情中书写青春传奇，美少年们的热血史诗。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20illustration%20of%20young%20handsome%20Silla%20dynasty%20warriors%20in%20traditional%20armor%2C%20mountain%20landscape%20background%2C%20dramatic%20sky%2C%20epic%20historical%20atmosphere%2C%20beautiful%20hanbok%20details%2C%20gold%20and%20jade%20color%20palette%2C%20poetic%20composition&width=800&height=1067&seq=all-comic-17&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Park Minji',
    rating: 4.5,
    views: '1234万',
    chapters: 178,
    tags: ['历史', '青春', '爱情', '冒险'],
    isHot: false,
    isNew: false,
  },
  {
    id: 18,
    title: '深渊之眼',
    slug: 'abyss-eye',
    category: '惊悚',
    categorySlug: 'thriller',
    description: '一名心理医生在治疗特殊病人时发现惊人秘密，每一个病例背后都隐藏着不可告人的真相。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20psychological%20thriller%20manhwa%20illustration%20of%20a%20mysterious%20psychiatrist%20office%20with%20strange%20shadows%2C%20unsettling%20atmosphere%2C%20dark%20and%20cool%20color%20palette%2C%20suspenseful%20horror%20mood%2C%20creepy%20details%2C%20noir%20style%20lighting%2C%20mysterious%20patient%20silhouette&width=800&height=1067&seq=all-comic-18&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Kang Hyunwoo',
    rating: 4.7,
    views: '2678万',
    chapters: 156,
    tags: ['惊悚', '心理', '悬疑', '推理'],
    isHot: true,
    isNew: false,
  },
  {
    id: 19,
    title: '再见我的公主',
    slug: 'goodbye-princess',
    category: '剧情',
    categorySlug: 'drama',
    description: '落魄贵族小姐与平民青年跨越阶层的爱情故事，在社会偏见与家族压力下的艰难抉择。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20melodrama%20manhwa%20illustration%20of%20a%20elegant%20noblewoman%20and%20humble%20young%20man%20in%20a%20garden%20at%20sunset%2C%20bittersweet%20romantic%20atmosphere%2C%20warm%20golden%20light%2C%20emotional%20scene%2C%20period%20drama%20setting%2C%20soft%20focus%2C%20poetic%20composition%2C%20vintage%20aesthetic&width=800&height=1067&seq=all-comic-19&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Song Hyemi',
    rating: 4.6,
    views: '1987万',
    chapters: 123,
    tags: ['剧情', '爱情', '阶层', '时代'],
    isHot: false,
    isNew: true,
  },
  {
    id: 20,
    title: '黑帮高中',
    slug: 'gang-high-school',
    category: '动作',
    categorySlug: 'action',
    description: '全国不良少年汇聚的暴力高中，一个平凡转学生的生存之战，拳拳到肉的热血校园故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20illustration%20of%20high%20school%20students%20in%20a%20fierce%20street%20fight%2C%20urban%20school%20setting%2C%20dynamic%20fighting%20poses%2C%20gritty%20realistic%20style%2C%20dramatic%20camera%20angles%2C%20intense%20energy%2C%20dark%20urban%20atmosphere%2C%20cool%20blue%20and%20red%20contrast&width=800&height=1067&seq=all-comic-20&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Park Taejoon',
    rating: 4.4,
    views: '4321万',
    chapters: 267,
    tags: ['动作', '校园', '格斗', '热血'],
    isHot: true,
    isNew: false,
  },
  {
    id: 21,
    title: '网红星计划',
    slug: 'influencer-star',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '普通女孩误打误撞成为顶级网红，在光鲜亮丽的社交媒体背后是一连串令人捧腹的乌龙事件。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20illustration%20of%20a%20funny%20young%20woman%20surrounded%20by%20social%20media%20icons%20and%20likes%20floating%20around%2C%20bright%20neon%20colors%2C%20modern%20smartphone%20culture%2C%20exaggerated%20happy%20expression%2C%20pop%20art%20style%2C%20vibrant%20energetic%20atmosphere&width=800&height=1067&seq=all-comic-21&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    author: 'Kim Sohee',
    rating: 4.2,
    views: '1345万',
    chapters: 78,
    tags: ['搞笑', '网红', '现代', '喜剧'],
    isHot: false,
    isNew: true,
  },
];

export const allComics: ComicItem[] = [
  ...heroComics,
  ...hotComics,
  ...latestComics,
  ...extraComics,
];